import React, { ReactNode } from "react"
import { graphql } from "gatsby"
import { FAQGroupBlock } from "./FAQGroupBlock"
import type { FaqsGroup } from "./faq-types"

interface FAQGroupBannerProps {
  alt_background_color?: boolean
  children: ReactNode
  eyebrow_text?: string
  faqs: FaqsGroup
  heading?: string
  is_faq_item_collapsable: boolean
  sub_heading?: string
}

//Note Eyebrow Text is available, It was not utilized in this theme for this component

export const FAQGroupBanner = ({
  // eyebrow_text,
  alt_background_color = false,
  faqs,
  heading,
  is_faq_item_collapsable = false,
  sub_heading,
}: FAQGroupBannerProps) => {
  const altBgColor = alt_background_color ? " alternate-background-color" : ""

  return (
    <section className={`fr-group-banner u-content-block-padding${altBgColor}`}>
      <div className="fr-container">
        {(heading || sub_heading) && (
          <div className="text-content-block__title">
            {heading && <h2>{heading}</h2>}
            {sub_heading && <h3>{sub_heading}</h3>}
          </div>
        )}
        <FAQGroupBlock faqs={faqs} isCollapsable={is_faq_item_collapsable} />
      </div>
    </section>
  )
}

export const strapiQuery = graphql`
  fragment StrapiFaqGroupBannerFragment on STRAPI__COMPONENT_CONTENT_BLOCK_FAQ_GROUP_BANNER {
    alt_background_color
    eyebrow_text
    faqs {
      ...StrapiFaqFragment
    }
    heading
    id
    is_faq_item_collapsable
    strapi_component
    sub_heading
  }
`
